export default __webpack_public_path__ + "images/Player-de8e24d37cde29a5dea33e0e971de580.png";